/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Invite_Not_FoundInputs */

const en_us2_club_invite_not_found = /** @type {(inputs: Club_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No club has that code.`)
};

const pt_br2_club_invite_not_found = /** @type {(inputs: Club_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum clube com esse código.`)
};

const es_419_club_invite_not_found = /** @type {(inputs: Club_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún club tiene ese código.`)
};

const pt_pt2_club_invite_not_found = /** @type {(inputs: Club_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum clube tem esse código.`)
};

const fr_fr2_club_invite_not_found = /** @type {(inputs: Club_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun club n'a ce code.`)
};

const de_de2_club_invite_not_found = /** @type {(inputs: Club_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Club hat diesen Code.`)
};

const it_it2_club_invite_not_found = /** @type {(inputs: Club_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun club ha questo codice.`)
};

/**
* | output |
* | --- |
* | "No club has that code." |
*
* @param {Club_Invite_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_invite_not_found = /** @type {((inputs?: Club_Invite_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Invite_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_invite_not_found(inputs)
	if (locale === "es-419") return es_419_club_invite_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_club_invite_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_club_invite_not_found(inputs)
	if (locale === "de-DE") return de_de2_club_invite_not_found(inputs)
	if (locale === "it-IT") return it_it2_club_invite_not_found(inputs)
	return en_us2_club_invite_not_found(inputs)
});
export { club_invite_not_found as "club.invite_not_found" }